// src/components/layout/AppLayout.tsx
import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header'; // si tienes Header
import * as S from './Sidebar.styles'; // estilos compartidos
import { canAccessWebPortal, clearSession, hasValidSession } from '../../helpers/session';

const AppLayout: React.FC = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  // Sin sesión válida (usuario y token vigente) no se permite ver ninguna ruta protegida.
  if (!hasValidSession()) {
    clearSession();
    return <Navigate to="/" replace />;
  }

  if (!canAccessWebPortal()) {
    clearSession();
    return <Navigate to="/" replace />;
  }

  return (
    <S.LayoutContainer isSidebarOpen={isSidebarOpen}>
      <Sidebar isSidebarOpen={isSidebarOpen} />
      <div className="main-content">
        <S.ContentContainer>
          <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
          <Outlet />
        </S.ContentContainer>
      </div>
    </S.LayoutContainer>
  );
};

export default AppLayout;
